import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

export default function FileViewer() {
  const navigate = useNavigate();
  const { module, fileId } = useParams();
  const [src, setSrc] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkAuthAndLoadFile = async () => {
      try {
        const userRole = localStorage.getItem("userRole");
        const project = JSON.parse(localStorage.getItem("selectedProject"));
        
        console.log("FileViewer auth check:", {
          userRole,
          projectId: project?.id,
          module,
          fileId
        });
        
        if (!userRole || !project?.id) {
          console.log("FileViewer - Auth check failed:", {
            hasUserRole: !!userRole,
            hasProjectId: !!project?.id
          });
          navigate("/");
          return;
        }

        if (!module || !fileId) {
          console.log("FileViewer - Missing module or fileId");
          setError("Invalid file parameters");
          return;
        }

        // 统一使用API端点，由后端处理文件代理
        setSrc(`/api/file/plan/${fileId}`);

      } catch (error) {
        console.error("FileViewer - Error:", error);
        setError(error.message);
      }
    };

    checkAuthAndLoadFile();
  }, [module, fileId, navigate]);

  if (error) return <div className="text-red-500 p-4">{error}</div>;
  if (!src) return <div className="flex justify-center items-center h-screen">Loading...</div>;

  const viewerUrl = `/pdfjs/web/viewer.html?file=${encodeURIComponent(src)}`;
  console.log("Loading PDF viewer:", viewerUrl);

  return (
    <iframe
      title="pdfviewer"
      src={viewerUrl}
      style={{ width: "100%", height: "100vh", border: "none" }}
      onError={(e) => {
        console.error("PDF viewer iframe error:", e);
        setError("Failed to load PDF viewer");
      }}
    />
  );
}
